module.exports = __webpack_public_path__ + "static/media/ve.eae24efc.svg";